export default __webpack_public_path__ + "static/media/email.510547ce.webp";